import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=5078880d&scoped=true"
import script from "./OAuthLogin.vue?vue&type=script&lang=js"
export * from "./OAuthLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078880d",
  null
  
)

export default component.exports